export default __webpack_public_path__ + "static/media/detail_big_11_5.443eb188.jpg";